export const QUESTION_TYPE = {
  CHOOSE_DATE: 'choose-date',
  CHOOSE_MULTIPLE: 'choose-multiple',
  CHOOSE_ONE: 'choose-one',
  CHOOSE_PAYMENT: 'choose-payment',
  CHOOSE_PRODUCT: 'choose-product',
  DROPDOWN: 'dropdown',
  EMAIL: 'email',
  INFO: 'info',
  LOCATION: 'location',
  MATRIX: 'matrix',
  NUMERIC: 'numeric',
  OPEN_ANSWER: 'open-answer',
  PAIR: 'paired-questions',
  MAX_DIFF: 'max-diff',
  PAYPAL_EMAIL: 'paypal-email',
  PROFILE_CHART: 'profile',
  SLIDER: 'slider',
  SELECT_AND_JUSTIFY: 'select-and-justify',
  SHOW_PRODUCT_SCREEN: 'show-product-screen',
  TASTER_NAME: 'taster-name',
  UPLOAD: 'upload-picture',
  UPLOAD_VIDEO: 'upload-video',
  VERTICAL_RATING: 'vertical-rating',
  TRIANGLE_SET: 'triangle-test',
  MOBILE_PAYMENT: 'mobile-payment',
  RANKING: 'ranking'
}
